export default {
  login: {
    title: "SYSTEM LOGIN",
    logIn: "Login",
    username: "Account",
    password: "Password",
  },
  wrongpwd:
    "문자의 대소문자 + 수자는 8자 이하여서는 안되며 특수 기호는 지원하지 않는다",
  首页: "지갑",
  行情: "시세",
  财富: "자산",
  我的: "My",
  忘记密码: "비밀번호 찾기",
  确定: "확인",
  "忘记密码？": "비밀번호 찾기 ",
  登录: "로그인",
  注册: "회원가입",
  云端钱包: "지갑",
  世界顶尖安全保护: "세계 제일 안전금고",
  "独有资产增益，注册存币坐享收益": "마이닝을 해서 자산을 불리세요",
  "支持超过30+主流币和500+代币": "주요코인 및 토큰을 지원합니다",
  HD钱包: "안전금고",
  "100%掌管私钥，资产更放心": "완벽한 사유자산 보안",
  "一键导入助记词，方便好用": "니모닉으로 다른 지갑에서 불러오기 가능",
  设置登录密码: "비밀번호 설정",
  确认: "취소",
  手机注册: "휴대폰가입",
  已有账号: "이미 계정이 있습니다",
  去登录: "로그인",
  最近流行: "최신인기",
  全部: "전부",
  拖动排序: "ReLoad",
  立即创建: "지금 만들기",
  您支付: "지불금액",
  可换余额: "환전가능 금액",
  请在以下时间内完成支付以锁定此汇率: "환률로 인하여 지금 지불하세요",
  您获得: "받은 금액",
  "您获得的币种为空时,说明没有币种可以闪兑。":
    "코인을 선택하지 않으면 환전이 되지 않습니다.",
  立即兑换: "환전",
  备份钱包助记词: "니모닉을 주의해서 보관하세요",
  "1.由12个字符组成，请抄写并保管在安全的地方。":
    "1. 12개 단어를 적어서 보관하세요",
  "2.100%由您保管，一经丢失，无法找回。":
    "2. 100% 개인책임으로 분실시 찾을 수 없습니다",
  "3.请在收币或卸载之前，务必完成助记词备份。":
    "3. 앱 삭제나 입금전 반드시 니모닉을 보관하세요",
  立即备份: "적어서 보관하세요",
  "我先看看，稍后再说": "잠시후",
  请环顾四周: "주변에 노출 안되게 주의해주세요",
  "任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。":
    "니모닉 유출시 자산 분실의 위험이 있으니 항상 주의하세요",
  知道了: "확인",
  请输入验证码: "인증코드를 입력하세요",
  "没有收到验证码？": "인증코드를 못받으셨나요?",
  交易时间: "거래 시간",
  交易ID: "거래ID",
  来自: "송금인",
  发送到: "보낸ID",
  备注: "비고",
  发送: "발송",
  闪兑: "환전",
  接收: "입금",
  交易记录: "거래내역",
  "正在刷新...": "로딩중",
  "正在加载...": "로딩중",
  暂无相关记录: "내역이 없습니다.",
  重新设置支付密码: "지불 비밀번호 재설정",
  "请将上方的16位恢复秘钥备份在安全的地方，遗失秘钥将无法恢复两步验证":
    "16개의 니모닉 단어들을 안전한 곳에서 진행하세요",
  我已设置并备份秘钥: "니모닉 백업 및 설정을 마쳤습니다",
  "谷歌两步验证可以为您的账户增加一层保护，当您登陆或者进行交易时，在输入密码的同时，还需要来自两步验证的验证码":
    "구글 OPT 를 사용하면 더 안전해집니다",
  "如何使用谷歌两步验证?": "구글 OPT 사용방법",
  筛选: "선택",
  移除: "삭제",
  添加: "추가",
  总资产: "총자산",
  创建钱包: "지갑 만들기",
  导入钱包: "지갑 불러오기",
  邀请好友: "친구초대",
  发红包: "선물 보내기",
  扫一扫: "QR 촬영",
  地址簿: "주소록",
  历史公告: "공지",
  设置: "설정",
  请选择您的证件的颁发国家: "국가 설정을 해주세요",
  查看助记词: "니모닉 보기",
  "您可以导入一下助记词在其他设备上配对，或者用其他设备上的 HMC Wallet Pro 钱包扫描二维码配对。":
    "휴대폰 교체시 QR 코드나 니모닉으로 지갑을 불러올수 있습니다",
  "请勿截图！如果有人获取你的助记词将直接获取你的资产！":
    "니모닉을 캡쳐하지 마세요",
  查看加密二维码: "암호화 QR코드 보기",
  "加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。":
    "암호화 QR코드는 새로운 기기에 지갑을 불러오기위해 사용합니다",
  "该二维码仅限 HMC Wallet Pro 钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。":
    "본 QR코드는 지갑에서만 사용하는 비밀번호화 같이 사용하는 QR 코드입니다 ",
  "请抄写 HMC Wallet Pro 助记词": "니모닉을 적어주세요",
  "HMC Wallet Pro 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。":
    "니모닉 12개를 순서대로 적어서 보관해주세요",
  我已安全保存: "먼저 주위가 안전한지 확인하세요",
  "HMC Wallet Pro需要您提政府颁发的照片ID来通过安全验证": "신분인증을 해주세요",
  提交: "제출하기",
  设置收款金额: "입금금액 설정",
  收款金额: "입금금액 ",
  复制收款码: "주소복사 ",
  取消: "확인",
  数量: "수량 ",
  "为了您的账户安全,请输入原支付密码确认身份。": "현재 PIN을 입력하세요",
  "忘记支付密码?": "지불 비밀번호 재설정",
  将配好的红包分享给好友: "선물하기를 공유하세요",
  个: "개",
  "请确认 HMC Wallet Pro 助记词": "니모닉을 확인해주세요",
  "为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。":
    "니모닉을 순서대로 선택해주세요",
  "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。":
    "자산의 안전을 위해 추가 보안 설정 및 실명정보가 필요하며 설정시 등급에 따라 인출 한도가 증가합니다.",
  恢复助记词钱包: "니모닉으로 지갑 불러오기",
  "请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词":
    "단어입력후 칸 띄우기(스페이스)를 누르면 다음칸으로 이동합니다",
  开始恢复: "불러오기",
  "覆盖当前钱包？": "불러온 지갑을 적용하시겠습니까",
  "导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。":
    "새로운 데이터를 적용시키면 이전 데이터는 사라집니다. 현재 니모닉을 잘 보관해두세요",
  继续导入: "계속",
  全部发送: "전부 발송",
  交易费: "수수료",
  慢: "저속",
  快: "고속",
  已有红包: "받은 선물",
  生成红包: "선물 생성",
  确认支付: "확인",
  可在已有红包页面查看领取详情: "선물 페이지에서 내역을 확인하세요",
  级: "급",
  退出登录: "로그아웃",
  全部划转: "전부 보내기",
  查看规则: "규정 보기",
  请输入支付密码: "지불 비밀번호 입력",
  币计划活期: "예금",
  币计划定期: "적금",
  预期年化收益: "연 수익률",
  我的财富: "총 자산",
  币计划: "CoinPlan",
  热门推荐: "추천상품",
  交易查询: "거래내역",
  财富资产: "총 자산",
  累计收益: "수익누적",
  预期年化收益率: "예상 연 수익률",
  交易规则: "거래 규정",
  买入: "구매 ",
  起息日: "시작일",
  到期日: "만료일",
  产品亮点: "상품장단점",
  剩余额度: "남은잔액 ",
  立即购买: "잔액 ",
  昨日收益: "이전 수익",
  划入: "입금",
  划出: "이체",
  全部划出: "전부 이체",
  请输入谷歌二次验证码: "구글 OTP 코드를 입력하세요",
  点击登录: "로그인 ",
  "欢迎来到HMC Wallet Pro": "HPC에 오신것을 환영합니다",
  邀请奖励: "초대 인센티브",
  每日快讯: "뉴스",
  联系客服: "고객센터",
  邀请累计: "누적적립금",
  积分: "포인트",
  好友注册人数: "초대 내역",
  好友注册: "초대등록",
  人数: "명",
  一级好友数: "1급 맴버",
  "积分 每人奖励": "1인당 {msg}포인트 적립",
  "积分 每人奖励2": "1인당 {msg}포인트 적립",
  二级好友数: "2급 맴버",
  三级好友数: "3급 맴버",
  一级好友数2: "1급 맴버",
  二级好友数2: "2급 맴버",
  三级好友数2: "3급 맴버",
  好友存币数: "예금초대",
  邀请列表: "초대목록",
  邀请注册: "초대등록",
  邀请存币: "예금초대",
  暂时没有邀请哦: "데이터 없음",
  当前总额: "현재 총 자산",
  积分账单: "인센티브 내역",
  任务: "미션",
  商城: "쇼핑몰",
  "忘记PIN码？备份钱包后重新安装App并导入助记词后重置":
    "Pin 코드를 잊으셨나요? 니모닉 보관 후 App을 재설치 하세요",
  "为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。":
    "자산의 보안을 위하여 PIN 코드를 설정하세요",
  "PIN码为本地密码，请妥善保存，如果丢失，无法恢复":
    "PIN 코드를 잊으시면 백업할 수 없습니다",
  关闭PIN码: "PIN 코드 닫기",
  "扫码下载HMC Wallet Pro": "스캔코드 다운로드",
  "邀请码(点击复制)": "초대코드(복사하기)",
  查看邀请详情: "초대 상세보기",
  我的订单: "구매",
  正在进行中: "진행중",
  已经结束: "만기",
  人参与: "명 참여중",
  兑换金额: "교환 금액",
  商品详情: "상품설명",
  兑换时间: "교환 시간",
  开始时间: "시작 시간",
  结束时间: "만기 시간",
  我的积分: "인센티브",
  我的剩余兑换额度: "남은 교환 잔액",
  库存总量: "잔고 ",
  剩余库存: "잔고 ",
  兑换比例: "교환 비율",
  确认兑换: "확인",
  任务记录: "미션 내역",
  分享: "공유",
  请填写手机号: "휴대폰 번호를 입력하세요 ",
  验证码: "인증코드",
  设置密码: "비밀번호를 입력하세요",
  再次输入: "비밀번호를 다시 입력하세요",
  请填写密码: "비밀번호를 입력하세요",
  邀请码: "초대코드(선택)",
  我的Dapp钱包: "지갑",
  发现: "찾기",
  搜索: "검색",
  自定义排序: "정렬 설정",
  货币: "화폐",
  创建新地址: "주소 만들기",
  名称: "코인이름",
  地址: "주소",
  请输入金额: "금액을 입력하세요",
  验证您的身份: "신분인증",
  选择币种: "코인선택",
  设置支付密码: "PIN 설정",
  谷歌两步验证码: "구글 OTP코드",
  谷歌两步验证: "구글 인증",
  请输入搜索内容: "검색 내용을 입력하세요",
  选择证件类型: "신분증 종류 선택",
  支付密码: "PIN",
  修改支付密码: "PIN 변경",
  认证资料: "인증 자료",
  国家: "국가",
  您的居住国家: "현 거주 국가",
  姓名: "성명",
  您的姓名全称: "실명을 입력하세요",
  生日: "생일",
  居住地: "거주지",
  您现在的居住地: "현 거주지",
  证件ID: "신분ID",
  您的证件ID号码: "주민등록번호",
  ID正面照片: "신분증 정면 사진",
  ID反面照片: "신분증 뒷면 사진",
  请输入数值: "수량을 입력하세요",
  已配置红包: "선물 설정",
  重置支付密码: "PIN 변경",
  红包详情: "선물 내역",
  安全等级: "보안등급",
  请输入收款地址: "입금주소를 입력하세요",
  "备注(选填)": "메세지",
  配置红包: "선물 설정",
  金额: "금액",
  红包数: "선물 수량",
  请填写个数: "수량을 입력하세요",
  红包总额度: "선물 총 수량",
  红包数量: "선물 수량",
  祝福语: "메시지",
  选择发送途径: "공유방법 선택",
  云端钱包设置: "설정",
  账户名称: "계정 ID",
  注册时间: "가입일자",
  请输入划入金额: "수량을 입력하세요",
  请输入转出金额: "수량을 입력하세요",
  谷歌二次验证: "구글 인증",
  默认货币: "기본통화",
  PIN码: "PIN코드",
  行情选项: "시세선택",
  服务协议: "이용약관",
  隐私政策: "개인정보 보호정책",
  帮助中心: "도움말",
  加入社群: "Telegram",
  我的邀请: "초대 상세보기",
  验证PIN码: "PIN 인증코드",
  设置PIN码: "PIN 코드설정",
  行情显示色选项: "시세 UP/DOWN",
  请输入兑换金额: "교환금액 입금 하세요 ",
  任务中心: "미션",
  快讯: "새소식",
  "已开启(重置)": "기능 설정",
  已开启: "PIN 설정",
  未开启: "미설정",
  绿涨红跌: "Up : 녹색 / Down : 적색",
  红涨绿跌: "Up : 적색 / Down : 녹색",
  全部交易: "모든거래",
  增益收入: "수익",
  全部产品: "모든제품",
  全部币种: "모든코인",
  当前余额: "현재 잔액 ",
  钱包: "지갑",
  今日获得: "오늘 받기",
  "我已备份好当前钱包，同意覆盖": "업로드 하시겠습니까?",
  备份助记词: "백업 니모닉",
  "助记词即为私钥，它是掌管您财产的钥匙":
    "니모닉은 사유자산이므로 잘 보관하세요",
  完成: "마치다",
  下一步: "다음 단계",
  默认语言: "언어선택",
  "没有HMC Wallet Pro账号？": "계정이 없습니까?",
  获取验证码: "인증코드발송",
  验证错误: "유효성 검사 오류",
  验证成功: "성공적으로 확인됨",
  验证失败: "확인 실패",
  设置成功: "성공적으로 설정",
  请选择同意: "동의를 선택해주세요",
  云端钱包公告: "클라우드 지갑 공지",
  HD钱包公告: "HD 지갑 발표",
  云端钱包地址簿: "클라우드 지갑 주소록",
  HD钱包地址簿: "HD 지갑 주소록",
  收款地址: "입금",
  请填写完整: "빈칸을 모두 채워주세요",
  复制成功: "복사성공 ",
  复制出现异常: "복사실패",
  资产名: "이름",
  交易量: "용량",
  价格: "가격",
  "涨跌幅(24H)": "변화(24H)",
  内部转账: "내부거래",
  外部转账: "외부거래",
  请输入收款用户ID: "받는 사람 사용자 ID를 입력하십시오",
  公链: " Chain",
  游戏: "Game",
  手机登录: "휴대폰로그인",
  我的游戏: "Game",
  社区: "커뮤니티",
  链游: "관련상품",
  全部动态: "모든 게시물",
  热门游戏: "인기 게임",
  我的关注: "즐겨찾기",
  发布: "게시",
  分享新鲜事: "새로운 소식을 공유하세요",
  发布动态: "게시글 쓰기",
  个人主页: "프로필 편집",
  全文: "전체 텍스트",
  评论: "논평",
  赞: "엄청난",
  没有更多了: "더 이상은 없어",
  暂无数据: "데이터가 없습니다.",
  提示: "힌트",
  请选择文件: "파일을 선택하세요",
  请输入动态内容: "동적 콘텐츠를 입력하세요.",
  确定删除该图片吗: "이 사진을 삭제하시겠습니까?",
  上传文件类型错误: "잘못된 업로드 파일 형식",
  请选择要上传的图片: "업로드할 이미지를 선택하세요",
  匿名用户: "익명 사용자",
  收起: "치워",
  查看所有评论: "모든댓글보기",
  确定删除该动态吗: "이 활동을 삭제하려면 확인",
  动态详情: "동적 세부정보",
  删除: "삭제",
  有趣的评论万里挑一: "백만분의 1의 재미있는 댓글",
  请输入内容: "내용을 입력해주세요",
  回复: "회신하다",
  暂无签名: "아직 서명이 없습니다.",
  已关注: "팔로우",
  关注: "에 초점",
  删除成功: "성공적으로 삭제되었습니다",
  打开: "열려있는",
  写下你的评论: "리뷰 작성",
  个人资料: "개인정보",
  点击修改: "수정하려면 클릭",
  昵称: "닉네임",
  ID: "ID",
  手机号: "휴대폰 번호",
  个性签名: "상태메세지",
  添加图片或视频: "사진 또는 비디오 추가",
  可用资产: "사용가능 자산 ",
  锁定资产: "동결자산",
  转账: "옮기다",
  收款: "수집",
  钱包管理: "초대",
  锁仓截止日期: "잠금 기한",
  锁定: "잠금",
  交易所: "플랫폼",
  量化交易: "양적 거래",
  角色信息: "역할 정보",
  绑定角色: "바인드 역할",
  服务区: "서비스 가능 지역",
  请选择服务区: "서비스 지역을 선택해 주세요",
  角色: "역할",
  请选择角色: "역할을 선택하세요.",
  绑定: "바인딩 성공",
  绑定成功: "바인딩 성공",
  立即绑定: "연동",
  未绑定: "연동됨",
  MetaEx交易所: "MetaEarth EX  ",
  AI机器人: "Areph Bot  ",
  邮箱注册: "이메일가입",
  请填写邮箱号: "이메일을 입력하세요",
  返回首页: "지갑",
  BTC公链: "BTC 시리즈",
  ETH公链: "ETH 시리즈",
  HMC公链: "HMC 시리즈",
  HMC20: "HMC-20",
  实名认证: "실명인증",
  请先设置支付密码: "결제 비밀번호를 설정하세요",
  立即认证: "지금 인증",
  已认证: "인증됨",
  谷歌验证器: "구글인증",
  两步验证: "2단계 인증",
  "如何使用谷歌验证器?": "구글인증 설정방법",
  所有币种: "모든 통화",
  已添加币种: "추가된 통화",
  未添加币种: "통화가 추가되지 않음",
  币种: "화폐",
  邮箱: "이메일",
  手机: "휴대전화",
  获取: "얻다",
  推荐: "추천하다",
  利空: "약세",
  利好: "강세",
  请填写完整的助记词: "전체 니모닉 문구를 입력하세요.",
  "不是正确的助记词,请重新输入": "올바른 니모닉이 아닙니다. 다시 입력하세요.",
  邮箱登录: "이메일 가입",
  empty: "완전하게 작성하십시오",
  noequal: "두 개의 입력이 일치하지 않습니다",
  invite: "6자리 초대 코드를 입력하세요",
  修改密码: "비밀번호 수정",
  待审核: "검토를 기다리다",
  认证失败: "인증 실패",
  旧密码: "전 비밀번호를 입력하세요",
  新密码: "새 비밀번호를 입력하세요",
  请确认新密码: "비밀번호를 한번 더 입력하세요",
  立即修改: "확인",
  请填写完整表单: "전체 양식을 작성하십시오",
  两次密码不一致: "비밀번호가일치하지않습니다",
  认证状态: "실명인증",
  身份认证失败: "인증실패",
  失败原因: "실패원인",
  重新认证: "재인증",
  审核中: "심사중",
  已完成身份认证: "인증완료되었습니다",
  国籍: "국적",
  类型: "유형",
  身份证: "신분증",
  护照: "여권",
  驾照: "운전면허증",
  证件号码: "ID번호",
  已完成实名认证: "실명인증완료",
  身份验证: "인증",
  请输入手机验证码: "휴대폰인증번호를입력하세요",
  发送验证码: "발송",
  请输入邮箱验证码: "이메일 인증 코드를 입력하세요",
  请输入谷歌验证码: "구글인증번호를입력하십시오",
  输入邮箱验证码: "이메일 인증 코드를 입력하세요",
  输入手机验证码: "휴대폰인증번호입력",
  输入谷歌验证码: "구글인증번호입력",
  谷歌验证: "구글인증",
  立即验证: "확인",
  发送验证码至手机: "휴대폰으로 인증번호 보내기",
  发送验证码至邮箱: "이메일 인증",
  忘记支付密码: "PIN 분실",
  输入新密码: "새로운 PIN을 입력하세요",
  请再次输入: "새로운 PIN을 다시 입력하세요",
  请输入密码: "새로운 PIN을 입력하세요",
  请输入邮箱: "메일박스 입력",
  绑定邮箱: "사서함 바인딩",
  请输入手机号: "휴대폰번호를입력하세요",
  区号: "지역번호",
  请选择区号: "지역 번호를 선택해 주세요",
  绑定手机号: "핸드폰번호연동",
  "谷歌验证可以为您的账户增加一层保护，当您登录或者进行交易时，再输密码的同时，还需要来自谷歌验证的验证码":
    "구글인증 사용 시 계정에 보호 기능이 추가되며 로그인 또는 거래시 비밀번호 입력과 함께 구글에서 발급받은 인증번호가 필요합니다.",
  // "如何使用谷歌验证器?": "구글 인증기는 어떻게 사용하나?",
  可用余额不足: "잔고부족",
  地址格式不正确: "주소형식이잘못되었습니다",
  金额不足10: "금액 10 미만",
  提币数量不能小于: "인출금액이보유금액보다큽니다",
  "您还未进行实名认证,请先进行实名认证":
    "아직실명인증을하지않았으니실명인증먼저해주십시오",
  至少为10: "최소 10",
  全选: "모두선택",
  删除: "취소",
  请先勾选地址: "주소부터 체크해주세요",
  新建地址: "새주소",
  提币网络: "메인넷",
  收款网络: "메인넷",
  "操作成功!": "처리성공",
  韩国: "한국",
  日本: "일본",
  其他: "기타",
  请上传手持证件照片: "신분증을들고있는사진을올려주세요",
  请把信息填写完整: "정보를 완전하게 써 주세요",
  请上传所需图片: "원하는 사진을 올려주세요",
  两步验证登录: "로그인인증",
  请选择验证方式: "인증 방식을 선택해주세요",
  验证方式: "인증 방식을 선택하세요",
  验证登录: "로그인 인증",
  短信验证: "SNS인증",
  证件类型: "증명서종류",
  暂无内容: "잠시내용이없습니다",
  邮箱地址不符合格式: "이메일주소가형식에맞지않습니다",
  下拉刷新: "드롭다운 새로 고침",
  释放更新: "업데이트 릴리스",
  修改个性签名: "상태메세지 수정",
  修改昵称: "닉네임변경",
  导入NFT: "NFT 가져오기",
  请输入NFT合约地址: "NFT 컨트랙트 주소를 입력해주세요",
  请输入收藏品ID: "컬렉션 ID를 입력하세요",
  保存收款碼: "QR코드 저장",
  PoS挖矿: "PoS 마이닝",
  加入社群2: "Telegram 채팅방 참여",
  "没有HMC Wallet Pro账号？ 注册": "회원가입",
  邮箱验证: "이메일인증",
  手机验证: "휴대폰인증",
  "已有账号，去登录": "이미 가입을 되어 있다면 이곳을 클릭하세요",
  导入NFT: "NFT 가져오기",
  接收地址: "받는 주소",
  添加收藏品: "즐겨찾기 추가",
  暂无NFT收藏: "아직 NFT 수집 없음",
  编号: "일련 번호",
  删除: "삭제",
  转出: "전출하다",
  确认删除此收藏品吗: "이 컬렉션을 삭제하시겠습니까",
  确认删除此专辑吗: "이 앨범을 삭제하시겠습니까",
  地址: "주소",
  请输入NFT合约地址: "NFT 계약 주소를 입력하세요",
  请输入收藏品ID: "컬렉션 ID를 입력하세요",
  添加: "추가",
  NFT接收地址: "NFT 수신 주소",
  复制: "복사",
  此地址仅用于NFT钱包地址接收使用:
    "이 주소는 NFT 지갑 주소 수신에만 사용됩니다",
  转出NFT: "NFT 이체",
  合约地址: "계약 주소",
  转出网络: "네트워크 이전",
  藏品编号: "컬렉션 번호",
  转出地址: "반출 주소",
  "此交易属不可逆,为避免您的资产损失,请仔细核对转出地址、网络,是否准确无误。":
    "이 거래는 되돌릴 수 없습니다. 자산 손실을 방지하려면 송금 주소와 네트워크가 정확한지 주의 깊게 확인하십시오.",
  请输入转出地址: "송금주소를 입력해주세요",
  NFT历史记录: "NFT 기록",
  时间: "시간",
  转入详情: "전입 상세 정보",
  已转出: "이동됨",
  交易详情: "거래 상세 정보",
  发送地址: "발송 주소",
  接收地址: "수신 주소",
  网络: "네트워크",
  交易哈希: "거래 해시",
  NFT合约地址: "NFT 계약 주소",
  NFT编号: "NFT 번호",
  交易时间: "거래 시간",
  保存收款码:"QR코드 이미지 저장"
};
